import { AlertDialog, useDialog as useDaxDialog } from '@global-dax-ad-platform/dax-components';
import { Button, Typography } from '@global-engineering-shared/gweb-material-ui';
import { capitalize } from 'lodash-es';

import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import {
  ActionType,
  entityActionUrls,
} from 'features/Entity/components/EntityActionBar/utils/entityActionUrls';
import { getEntityTitle } from 'features/Entity/components/EntityActionBar/utils/getEntityTitle';
import useFetchData from 'hooks/useFetchData';
import { EntityType } from 'types/entityType';
import { ENTITY_ACTION_DIALOG_ID } from 'utils/defaults';

export interface IEntityActionButtonProps {
  spaceId: string;
  entityType: EntityType.FRAME | EntityType.LINKED_ASSET;
  action: ActionType;
}

const EntityActionButton = ({ spaceId, entityType, action }: IEntityActionButtonProps) => {
  const dialogId = ENTITY_ACTION_DIALOG_ID + action;
  const { openDialog: openDaxDialog } = useDaxDialog();
  const { patchData } = useFetchData();
  const { triggerRefresh } = useRefresh();

  const handleContinue = async () => {
    const urls = entityActionUrls[entityType];
    if (urls && urls[action]) {
      await patchData(urls[action], [spaceId]);
      triggerRefresh();
    }
  };
  return (
    <>
      <AlertDialog
        dialogId={dialogId}
        content={{
          title: `${capitalize(action)} ${getEntityTitle(entityType)}`,
          main: (
            <Typography color="textPrimary" variant="body2">
              Click continue to <strong>{action}</strong> {getEntityTitle(entityType)}{' '}
              <strong>{spaceId}</strong>
            </Typography>
          ),
        }}
        action={{
          label: 'Continue',
          onClick: () => handleContinue(),
        }}
      />

      <Button
        onClick={() => openDaxDialog(dialogId)}
        color={(action === 'deactivate' || action === 'archive') && 'error'}
        fontWeight={500}
        variant="outlined"
      >
        {capitalize(action)} {getEntityTitle(entityType)}
      </Button>
    </>
  );
};

export default EntityActionButton;
